import React from 'react';
import { Resources, GlobalLayout } from '../'

const ResourcesPage = () => (
  <GlobalLayout>
    <Resources />
  </GlobalLayout>
);

export default ResourcesPage;